import { Component } from '@angular/core';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';

@Component({
    selector: 'app-management-header',
    templateUrl: './management-header.component.html',
    styleUrls: ['./management-header.component.scss'],
    standalone: false
})
export class ManagementHeaderComponent {
    IA = LogoNames.IA;
    headerMenuSelfDisplay = false;
    headerMenuCSSClasses;

    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
}
